import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	LogoImg: styled.img`
		height: 180px;
	`,

	Tab: styled.button`
		${({theme}) => theme.font.small_bold};

		${({$selected}) =>
			$selected &&
			css`
				${({theme}) => theme.font.small_bold};
				color: ${({theme}) => theme.color.major};
			`}
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,
	InputWrapper: styled.div`
		height: 40px;
		display: flex;
		gap: 8px;

		& > input {
			width: 100%;
			${({theme}) => theme.font.extra_small};
			padding: 0 20px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
	AreaDivTable: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;
		align-items: center;

		& > h2 {
			${({theme}) => theme.font.small_bold};
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 8px;
		}
	`
}

export default Style
